<template lang="pug">
.fund-wrap
  .fund
    .sectors-chart-wrap
      .sectors
        .title sectors
        .sector(v-for="(percent, sector) in stats.sectorPercentages")
          span.percent {{ adjustPercent(percent) }}%&nbsp;
          | &mdash; {{ sector }}
      keep-alive
        canvas.sectors-chart(ref="sectors", width="100", height="100")
    .distribution-wrap
      .title distribution
      .distribution
        vc-donut(:sections="distributions('Large')",
                 :thickness="15",
                 :size="150",
                 foreground="#f6f6f6")
        vc-donut.mid(:sections="distributions('Mid')",
                 :thickness="15",
                 :size="120",
                 foreground="#f6f6f6",
                 :start-angle="(values('Large').total / 100) * 360")
        vc-donut.small(:sections="distributions('Small')",
                 :thickness="15",
                 :size="95",
                 foreground="#f6f6f6",
                 has-legend,
                 legend-placement="bottom",
                 :start-angle="((values('Large').total + values('Mid').total) / 100) * 360")
          .sizes
            div large
            div mid
            div small
    .holdings-wrap
      .title % holdings
      .holdings
        vc-donut(v-for="(value, label) in { max: stats.maxPercentage, avg: stats.averagePercentage, med: stats.medianPercentage, min: stats.minPercentage, div: stats.paysDividendPercentages.True, 'new': stats.isNewPercentages.True }",
                 :sections="[{ value: adjustPercent(value, false), color: brn + '77' }]",
                 :thickness="15",
                 :size="42",
                 :foreground="brn + '1f'") {{ label }}
         .value {{ adjustPercent(value, false).toFixed(2).replace(/\.00$/, '') }}
    .regions-wrap
      .title regions
      .regions
        .region(v-for="(region, code) in engageRegions",
                :class="{ 'has-value': stats && stats.regionPercentages[region], [code]: true }",
                :title="region")
          span.label {{ code }}:
          span.value &nbsp;{{ stats && adjustPercent(stats.regionPercentages[region]) }}
          span.percent %
          span.nil &ndash;
</template>
<script>
//import { Chart, PolarAreaController, RadialLinearScale, ArcElement, Legend, Tooltip } from 'chart.js';
import { Chart, PieController, ArcElement, Legend, Tooltip } from 'chart.js';
import 'chartjs-adapter-moment';
//import ohlc from './ohlc';
import { mapGetters, mapActions } from 'vuex';
let ohlc;
export default {
  name: 'fund',
  computed: {
    ...mapGetters(['engage', 'engageSection', 'engageRegions']),
    brn: () => '#8D6E4F',
    stats() {
      return this.engage?.fund?.statistics;
    }
  },
  methods: {
    ...mapActions(['loadEngageRoboReport', 'toggleEngageSelectedDocument', 'toggleEngageSelectedPublisher', 'toggleSelectedWatchlistDocType', 'toggleEngageSelectedTheme']),
    values(size) {
      const { stats: { stylePercentages: sp } = {}, adjustPercent } = this;
      const value = adjustPercent(sp?.[`${ size } Cap Value`] || 0, false);
      const core = adjustPercent(sp?.[`${ size } Cap Core`] || 0, false);
      const growth = adjustPercent(sp?.[`${ size } Cap Growth`] || 0, false);
      //console.log('values', size, { value, core, growth, total: value + core + growth });
      return { value, core, growth, total: value + core + growth };
    },
    distributions(size) {
      const { values, brn } = this;
      const vs = values(size);
      const { value, core, growth } = values(size);
      return [
        { value, label: 'value', color: brn + '77' },
        { value: core, label: 'core', color: '#dadada' },
        { value: growth, label: 'growth', color: 'orange' }
      ];
    },
    adjustPercent(raw, round = true) {
      const { totalEquitiesHoldingsPercentage: tehp } = this.engage?.fund?.summary || {};
      const value = (tehp / 100) * raw;
      return round ? Math.round(raw) : raw;
      //return round ? Math.round(value) : value;
    }
  },
  // components: { viewer: () => import('@/components/topo-components/viewer'), reportCard, reportOpener, clipboard, highlighter } //,
  // components: { ohlc },
  async mounted() {
    const { stats, brn } = this;
    //console.log('fund mounted', stats, this.engage);
    /*
    --sectorPercentages

    regionPercentages
    collatedRegionPercentages

    --stylePercentages
    --collatedStylePercentages

    collatedCapPercentages

    --paysDividendPercentages
    --isNewPercentages
    --minPercentage
    --maxPercentage
    --averagePercentage
    --medianPercentage
    minPercentageTickers
    maxPercentageTickers
    */
    const {
      sectorPercentages: sectors//,
      // regionPercentages: regions,
      // collatedRegionPercentages: regionsCollated,
      // stylePercentages: styles,
      // collatedStylePercentages: stylesCollated,
      // collatedCapPercentages: capsCollated
    } = stats;
    const ctx = this.$refs.sectors.getContext('2d');
    console.log('registering...');
    // Chart.register(PolarAreaController, RadialLinearScale, ArcElement, ArcElement, Legend, Tooltip);
    Chart.register(PieController, ArcElement, Legend, Tooltip);
    console.log('registered');
    // const brn = '#8D6E4F';
    new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels: Object.keys(sectors),
        datasets: [
          {
            label: 'sectors',
            data: Object.values(sectors),
            arcBackgroundColor: brn + '77',
            arcHoverBackgroundColor: 'orange',
            arcHoverBorderColor: 'white',
            circumference: 240,
            rotation: -25,
            cutout: '85%',
            // barThickness: 2,
            borderWidth: 1,

            // borderRadius: 0.5
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
            //maxWidth: '20px',
            position: 'left',
            labels: {
              color: brn
            }
          },
          tooltip: {
            // Tooltip will only receive click events
            //events: ['click']
          }
        }/*,
        interaction: {
          intersect: false,
          mode: 'index'
        }*/
        /*tooltips: {
          callbacks: {
            label(tooltipItem, data) {
              let r = data.datasets[tooltipItem.datasetIndex].r || '';

              if (r) {
                r += ': ';
              }
              r += Math.round(tooltipItem.yLabel * 100) / 100;
              return r;
            }
          }
        },
        interaction: {
          intersect: false,
          mode: 'index'
        }
        },*/
        /*scales: {
          // lineWidth: false,
          y: {
            beginAtZero: false,
            position: 'right',
            grid: {
              display: false,
              color: '#fafafa',
              tickColor: brn,
              drawBorder: false
            }
          },
          xAxis: {
            // The axis for this scale is determined from the first letter of the id as `'x'`
            // It is recommended to specify `position` and / or `axis` explicitly.
            type: 'time',
            grid: {
              display: false
            }
          }
        }*/
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import '../../scss/global';
.fund-wrap {
  &.move-left {
    & > .fund {
      left: 1rem;
    }
  }
  .fund {
    display: grid;
    grid-template-columns: 16rem 12rem;
    grid-column-gap: 3rem;
    /*position: fixed;
    top: 5rem;
    bottom: 1rem;
    //left: 21vw;
    left: 51vw;
    //width: 76vw;
    width: 46vw;*/
    position: absolute;
    top: 1.5rem;
    z-index: 1;
    left: 37.5rem;
    height: 19.6rem;
    //width: 19.75rem;
    background-color: rgba(white, 0.5);
    transition: background-color 250ms ease-in-out;
    &:hover {
      background-color: white;
    }
    //height: 23rem;
    //max-width: 100vw;
    //min-height: 10vh;
    //width: 100vw;
    border: 1px solid #dadada;
    border-radius: 0.5rem;
    //box-shadow: 1px 1px 3px black;
    //border-radius: 0.25rem;
    //transform: translate3d(-110vw, 0, 0);
    //transform-origin: top left;
    //transition: transform 700ms ease-in-out;
    //will-change: transform;
    //z-index: -1;
    //cursor: default;
    //transform: none;
    box-sizing: border-box;
    padding: 1rem 1rem 0.5rem;

    &.shown {
      //transform: none;
    }
    .sectors-chart-wrap {
      width: 12rem;
      display: grid;
      grid-template-columns: 6rem 5rem;
      grid-column-gap: 1rem;
      .sectors {
        & > .title {
          white-space: nowrap;
          color: $brn;
          margin-top: -1rem;
          font-size: 1.8rem;
          font-family: 'Assistant', sans-serif;
          font-weight: 200;
          text-transform: uppercase;
          padding-left: 1rem;
          margin-bottom: 0.5rem;
          text-align: center;
          transform: translate3d(0, 0.5rem, 0);
        }
        .sector {
          white-space: nowrap;
          text-align: left;
          font-size: 0.7rem;
          font-family: 'Assistant', sans-serif;
          font-weight: 200;
          text-transform: uppercase;
          color: $brn;
          & > .percent {
            display: inline-block;
            width: 1.5rem;
            font-weight: 500;
            text-align: right;
          }
        }
      }
      .sectors-chart {
        width: 10rem;
        transform: translate3d(0.125rem, 0, 0);
        transform-origin: left center;
      }
    }
    .distribution-wrap {
      position: relative;
      left: -1rem;
      & > .title {
        white-space: nowrap;
        color: $brn;
        margin-top: -1rem;
        font-size: 1.8rem;
        font-family: 'Assistant', sans-serif;
        font-weight: 200;
        text-transform: uppercase;
        margin-bottom: -0.5rem;
        text-align: left;
        transform: translate3d(1rem, 0.5rem, 0);
      }
      .distribution {
        position: relative;
        top: 0.5rem;
        .mid {
          position: absolute;
          top: 0.95rem;
          left: 2.25rem;
        }
        .small {
          position: absolute;
          top: 1.70rem;
          left: 0 ;
        }
      }
      /deep/ {
        .cdc {
          transform: scale(0.9);
        }
        .cdc-legend {
          pointer-events: none;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          transform: translate3d(1rem, 0.25em, 0);
          transform-origin: top right;

          .cdc-legend-item {
            font-size: 0.7rem;
            margin-bottom: 0;
          }
        }
        .cdc-text {
          text-align: left;
          text-transform: uppercase;
          font-size: 0.7rem !important;
          .sizes {
            position: relative;
            top: 0.125rem;
            & > * {
              position: relative;
              left: 0.5rem;
              margin-bottom: 0.125rem;
              &::before {
                content: '';
                position: absolute;
                top: 1px;
                right: 100%;
                bottom: 1px;
                transform: translate3d(-0.25rem, 0, 0);
                width: 0.45rem;
                border-radius: 50%;
                border: 2px solid rgba($brn, 0.5);
              }
              & + * {
                &::before {
                  transform: translate3d(-0.25rem, 0, 0) scale(0.75);
                }
              }
              & + * + * {
                &::before {
                  transform: translate3d(-0.25rem, 0, 0) scale(0.5);
                }
              }
            }
          }
        }
      }
    }
    .holdings-wrap {
      & > .title {
        white-space: nowrap;
        color: $brn;
        margin-top: -1rem;
        font-size: 1.8rem;
        font-family: 'Assistant', sans-serif;
        font-weight: 200;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
        text-align: left;
        transform: translate3d(1rem, 0.5rem, 0);
      }
      .holdings {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        grid-column-gap: 0.25rem;
        grid-row-gap: 0.25rem;
        /deep/ .cdc-text {
          transform: translate3d(0, 0, 0);
          font-family: 'Assistant', sans-serif;
          font-size: 0.75rem !important;
          color: $brn;
          .value {
            position: relative;
            top: -0.25rem;
            font-weight: 500;
            font-size: 0.9rem;
          }
        }
      }
    }
    .regions-wrap {
      & > .title {
        white-space: nowrap;
        color: $brn;
        margin-top: -1rem;
        font-size: 1.8rem;
        font-family: 'Assistant', sans-serif;
        font-weight: 200;
        text-transform: uppercase;
        margin-bottom: 0.5rem;
        text-align: left;
        transform: translate3d(0, 0.5rem, 0);
      }
      .regions {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-column-gap: 0.06125rem;
        grid-row-gap: 0.25rem;
        transform: translate3d(-1.5rem, 0, 0);
        .region {
          white-space: nowrap;
          text-align: left;
          opacity: 0.5;
          color: $brn;
          font-size: 0.6rem;
          border: 1px solid transparent;
          border-radius: 0.25rem;
          padding: 0.25rem 0.25rem 0.125rem;
          &.am {
            .nil {
              display: inline-block;
              transform: translate3d(0.175rem, 0, 0);
            }
          }
          &.has-value {
            font-size: 0.7rem;
            opacity: 1;
            color: white;
            //border-color: rgba($brn, 0.25);
            border-color: white;
            background-color: rgba($brn, 0.4648);
            padding-top: 0.125rem;
            .value {
              font-size: 0.9rem;
              font-weight: 600;
              display: inline;
            }
            .percent {
              display: inline;
              //opacity: 0.65;
              opacity: 1;
              font-weight: 600;
            }
            .nil {
              display: none;
            }
          }
          .label {
            display: inline-block;
            width: 1.1rem;
            text-transform: uppercase;
            font-size: 0.7rem;
            font-weight: 500;
          }
          .value,
          .percent {
            display: none;
          }
        }
      }
    }
    & > .opener {
      cursor: pointer;
      display: none;
      position: fixed;
      top: 1rem;
      left: 110%;
      //margin-left: 3rem;
      //transform: translate3d(5.5rem, 0, 0);
      transform: translate3d(-2rem, 0, 0);
      font-size: 2rem;
      padding: 0.25rem 0.125rem;
      /*border-top-right-radius: 0.25rem;*/
      /*border-bottom-right-radius: 0.25rem;*/
      border-radius: 0.25rem;
      color: white;
      background-color: $brn;
      opacity: 0.75;
      transition: opacity 250ms ease-in-out 1500ms;
      will-change: opacity;
      &:hover {
        opacity: 1;
      }
    }
    &:not(.shown) > .opener {
      display: block;
      transition-delay: 10ms;
    }
  }
}
</style>
